<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qIvGpL/tc-custom/9781488047374.jpg?1702697743575" alt="This image is the cover for the book Daring to Love the Duke's Heir, The Beauchamp Heirs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daring to Love the Duke's Heir, The Beauchamp Heirs
      </h1>
      <p class="bookDescription body article font2">
        <p>She’s totally unsuitable…  …to be his duchess!  Part of The Beauchamp Heirs: Dominic Beauchamp, Lord Avon, is a powerful duke’s heir and it’s his duty to marry well. His bride must have impeccable breeding, manners and grace. But can anyone meet his exacting standards? Certainly not the irrepressible Liberty Lovejoy, who’s been thrust into society after years of being a provincial nobody. She’s too bold, too bubbly…so why is she the only lady he’s thinking about?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janice Preston
      </h2>
      
      <p class="authorDescription body article">Janice Preston writes sensual, emotional and heartwarming historical romance. Although all her novels are standalone reads, she loves to write stories set in the same Regency world, and many of her books include book-hopping characters. When Janice isn&#39;t writing she enjoys reading, pottering in the garden when the sun is shining, and travelling when she can. She fuels her imagination with endless cups of coffee, is far too keen on unhealthy food, and is an expert procrastinator.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57e914d2